import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';



export default function Footer(){

    const { t } = useTranslation();


    return (
        <div className="footerWrap">
            <div className="round"></div>
            <div className="content dfColG12">
                <div className="dfcsG16">
                    <Link to="/TermsPrivat" className="fw800">
                        <p>{t(`Message.home_tail_privacy_policy`)}</p>
                    </Link>
                    <Link to="/TermsOfUse">
                        <p>{t(`Message.home_tail_service_terms`)}</p>
                    </Link>
                    <p>{t(`Message.home_tail_subscription_info`)}</p>
                </div>
                <ul className="dfColG4">
                    <li className="dfcsG16">
                        <p>{t(`Message.my_order_hist_detail_company`)} : {t(`Message.home_tail_salee_korea`)}</p>
                    </li>
                    <li>{t(`Message.home_tail_business_reg_num`)}</li>
                    <li className="dfcsG8">{t(`Message.home_tail_order_business_reoprt_num`)} <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7788802870&apv_perm_no=" target="_black" className="ftCompBtn">사업자정보확인</a></li>
                    <li>주소: 세종특별자치시 부강면 갈산산수로 249</li>
                    <li><p>{t(`Message.home_tail_contack`)}</p></li>
                    <li className="pt8">
                        <p>평일 오전 9시 ~ 오후 6시 / 주말 및 공휴일 휴무</p>
                        <p>점심시간: 오전 11시30분 ~ 1시</p>
                    </li>
                    <li className="pt12">
                        <p>NICEPAY 구매안전서비스 : 고객님 안전거래를 위해 현금 결제 시 저희 쇼핑몰이 가입한 에스크로 (구매안전서비스)를 이용하실 수 있습니다. <a href="https://pg.nicepay.co.kr/issue/IssueEscrow.jsp?CoNo=7788802870" className="underLine" target="_black">가입사실 확인</a></p>
                    </li>
                    <li className="pt12">
                        <p>Salee B2C Platform (아시아푸드플랫폼)</p>
                    </li>
                </ul>
            </div>            
        </div>
    );
};